/**
 * PERMISSIONS
 * -----------
 * Canonical constants for every resource + action combination.
 * The shape matches the backend: { resource, actions }
 * Use these everywhere instead of raw strings to avoid typos.
 */

export const RESOURCES = {
    // ── Core modules ──────────────────────────────────────────
    DASHBOARD: 'dashboard',
    STORE: 'store',
    CATEGORY: 'category',
    PRODUCT: 'product',
    VARIANT: 'variant',
    ADDON: 'addon',
    ORDER: 'order',
    DISCOUNT: 'discount',
    COUPON: 'coupon',
    DRIVER: 'driver',
    CUSTOMER: 'customer',
    NOTIFICATION: 'notification',
    SETTINGS: 'settings',
    LIVE_ORDER: 'live-order',
    STAFF: 'staff',
    ROLE: 'role',
    REVIEW: 'review',
    HOME_LAYOUT: 'home-layout',
    TAG: 'tag',
    CASH_SETTLEMENT: 'cash-settlement',
    STORE_SETTLEMENT: 'store-settlement',
    ZONE: 'zone',
    RETURNS: 'return',
    ANALYTICS: 'analytics',
    PAYOUTS: 'payout',
    RETURN_REASON: "return-reason",
} as const;

export const ACTIONS = {
    VIEW: 'view',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
    APPROVE: 'approve',
    REJECT: 'reject',
    IMPORT_PRODUCT: 'import-product',
    ADD_STOCK: 'add-stock',
    BLOCK: "block",
    APPROVED_REJECTED: "approved-rejected",
    STORE_SETTINGS: "store-settings",
    ADMIN_SETTINGS: "admin-settings",
    EXPORT: 'export',
    // ASSIGN_DRIVER: "assign-driver",
} as const;

export type Resource = typeof RESOURCES[keyof typeof RESOURCES];
export type Action = typeof ACTIONS[keyof typeof ACTIONS];

/** A single permission check descriptor — matches the backend shape */
export interface PermissionCheck {
    resource: Resource;
    action: Action;
}
